import {
	Button,
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	RootDialogProps,
} from "@dune/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { deleteContact } from "../../api/mutations/contacts.mutations";
import { useGetContactDetails } from "../../api/queries/contacts.queries";
import { contactsQueryKeys } from "../../api/query-keys/contacts.query-keys";

export const DeleteContactDialog = (
	props: RootDialogProps & {
		contactToDeleteId: number;
	},
) => {
	const queryClient = useQueryClient();

	const { mutate: deleteContactMutate, isPending } = useMutation({
		mutationFn: deleteContact,
		onSuccess: () => {
			props.onOpenChange?.(false);
			queryClient.invalidateQueries({
				queryKey: contactsQueryKeys.all,
			});
		},
	});

	const { contact, isLoading } = useGetContactDetails(props.contactToDeleteId);

	if (isLoading) {
		return <Loader2 className="animate-spin" />;
	}

	return (
		<Dialog {...props}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Supprimer un contact</DialogTitle>
				</DialogHeader>

				<p>
					Voulez-vous supprimer le contact {contact?.firstname}{" "}
					{contact?.lastname} ?
				</p>

				<DialogFooter>
					<Button variant="outline" onClick={() => props.onOpenChange?.(false)}>
						Annuler
					</Button>
					<Button
						variant="destructive"
						isLoading={isPending}
						onClick={() => deleteContactMutate(props.contactToDeleteId)}
					>
						Supprimer
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
